import { useEffect, useState } from 'react'

const DonorBox = () => {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  if (!isClient) return null

  return (
    <div className="keela-embed-form" data-src="https://give-can.keela.co/embed/RrGEnDu5guCMJ6hoX">
      <div className="keela-loading">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  )
}

export default DonorBox
